var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "documentList" } }, [
            _vm._v("文档类型")
          ]),
          _c("el-menu-item", { attrs: { index: "reviewHistoryList" } }, [
            _vm._v("Review历史")
          ]),
          _c("el-menu-item", { attrs: { index: "operatingStatus" } }, [
            _vm._v("运行状态")
          ]),
          _c("el-menu-item", { attrs: { index: "publishList" } }, [
            _vm._v("发布记录")
          ])
        ],
        1
      ),
      _c("documentList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "documentList",
            expression: "activeIndex == 'documentList'"
          }
        ],
        ref: "documentList"
      }),
      _c("reviewHistoryList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "reviewHistoryList",
            expression: "activeIndex == 'reviewHistoryList'"
          }
        ],
        ref: "reviewHistoryList"
      }),
      _c("operatingStatus", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "operatingStatus",
            expression: "activeIndex == 'operatingStatus'"
          }
        ],
        ref: "operatingStatus"
      }),
      _c("publishList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "publishList",
            expression: "activeIndex == 'publishList'"
          }
        ],
        ref: "publishList"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }